import React from 'react';

import classes from './NavigationItems.css';

import NavigationItem from './NavigationItem/NavigationItem';
import getTokenData from '../../../JwtUtils';

const navigationItems = (props) => {

    let navigationItems = [
        { link: "/", label: "Home" },
        { link: "/signin", label: "Zaloguj się" },
        { link: "/signup", label: "Zarejestruj się" }
    ];
    
    //Landing page should not have header
    if(window.location.pathname.indexOf('_lp') > -1) {
        navigationItems = [];
    }

    if (localStorage.getItem('token')) {
        navigationItems = [
            { link: "/protected/dashboard", label: "Home" },
            { link: "/protected/products", label: "Polecane usługi" },
            { link: "/protected/my-trainings", label: "Moje usługi" },
            { link: "/protected/my-tools", label: "Moje narzędzia" },
            { link: "/protected/profile", label: "Moje postępy" },
            { link: "/protected/transactions", label: "Moje transakcje" },
            { link: "/logout", label: "Wyloguj się" },
        ];

        if(getTokenData('type') === 'ADMIN') {
            navigationItems = [
                { link: "/protected/verifications", label: "Weryfikacje wokalne" },
                { link: "/protected/songs", label: "Utwory do oceny" },
                { link: "/protected/samples", label: "Sample do oceny" },
                { link: "/protected/messages", label: "Wiadomości" },    
                { link: "/logout", label: "Wyloguj się" },
            ];
        }
    }

    return (<ul className={classes.NavigationItems}>
        {navigationItems.map(ni => <NavigationItem clicked={props.clicked} key={ni.label} link={ni.link} exact>{ni.label}</NavigationItem>)}
    </ul>);
}


export default navigationItems; 